import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import Audio from "@fae/source/utility/Audio.js"
import Navigation from "@fae/source/engine/navigating/Navigation.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import "./views/index.less"

export default {
    "key": "school",
    "title": "Hitherto",
    "subtitle": "School of Swordcery and Shieldjuration",
    "type": "jam",
    "firstChapterKey": "opening",
    "player": require("./player.js").default,
    "unitJobs": require("./unitJobs.jsx").default,
    "chapters": {
        "1": require("./chapters/opening").default,
        "punks": require("./chapters/punks").default,
        "jocks": require("./chapters/jocks").default,
        "preps": require("./chapters/preps").default,
        "prince": require("./chapters/prince").default,
        "teacher": require("./chapters/teacher").default,
    },
    "configuration": {
        "darkness": "none",
        "squigglevision": "world",
        // "immediateLevelups": true,
        "preserveExperienceEvenAfterDeath": true,
        "neverRenderUnitExperience": true,
        "alwaysRenderUnitLevel": true,
    },
    "credits": [
        "Andrew Goodenough",
        "Anna Arkhipova",
        "Doc McPherson",
    ],
    "overworld": {
        "currentTime": 0, // changed to 0 to accomodate the tutorial level
        "endTime": 8,
        // "image": require("./campus.jpg"),
        "images": [
            // {"url": require("./campus.jpg"), "size": "cover", "opacity": 0.5},
        ],
        "prompt": () => {
            if(App.game.player.overworld.currentTime >= App.game.overworld.endTime) {
                return (
                    <div class="OverworldPrompt">
                        <b>Exam Day!!</b>
                    </div>
                )
            }
            const days = App.game.overworld.endTime - App.game.player.overworld.currentTime
            return (
                <div class="OverworldPrompt">
                    <b>{days + " week" + (days != 1 ? "s" : "")}</b> to final exams!!
                </div>
            )
        },
        "locations": {
            "1": {
                "key": "1",
                "chapterKey": "punks",
                "position": {"x": 2, "y": 5},
                "title": "The Dorms",
                "subtitle": () => "Level " + Math.min(5, Math.max(1, Math.ceil((App?.game?.overworld?.currentTime ?? 1) / 2) + 0)),
                "icon": require("@fae/source/assets/images/teach-tactics/mapsprite-punkred.png"),
                "isDisplayed": () => App.game.player.overworld.currentTime >= 1,
                "isReachable": () => App.game.player.overworld.currentTime < App.game.overworld.endTime,
            },
            "2": {
                "key": "2",
                "chapterKey": "preps",
                "position": {"x": 12, "y": 4},
                "title": "The Library",
                "subtitle": () => "Level " + Math.min(5, Math.max(1, Math.floor((App?.game?.overworld?.currentTime ?? 1) / 2) + 1)),
                "icon": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPGREEN.png"),
                "isDisplayed": () => App.game.player.overworld.currentTime >= 2,
                "isReachable": () => App.game.player.overworld.currentTime < App.game.overworld.endTime,
            },
            "3": {
                "key": "3",
                "chapterKey": "jocks",
                "position": {"x": 5, "y": 7},
                "title": "The Quad",
                "subtitle": () => "Level " + Math.min(5, Math.max(1, Math.ceil((App?.game?.overworld?.currentTime ?? 1) / 2) + 1)),
                "icon": require("@fae/source/assets/images/teach-tactics/mapsprite-JOCKGREEN.png"),
                "isDisplayed": () => App.game.player.overworld.currentTime >= 3,
                "isReachable": () => App.game.player.overworld.currentTime < App.game.overworld.endTime,
            },
            "X": {
                "key": "teacher",
                "chapterKey": "teacher",
                "position": {"x": 11, "y": 7},
                "title": "The Study",
                "icon": require("@fae/source/assets/images/teach-tactics/mapsprite-teacher.png"),
                "isDisplayed": () => App.game.player.overworld.currentTime >= 4,
                "isReachable": () => App.game.player.overworld.currentTime >= 4,
            },
            "5": {
                "key": "5",
                "chapterKey": "prince",
                "position": {"x": 7, "y": 4.5},
                "title": "The Great Hall",
                "subtitle": "Level 5",
                "icon": require("@fae/source/assets/images/teach-tactics/mapsprite-PRINCE.png"),
                "isDisplayed": () => true,
                "isReachable": () => App.game.player.overworld.currentTime >= App.game.overworld.endTime,
            },
        },
    },
    "openingEvents": function() {
        return [
            {"func": () => Navigation.go("/games/school/chapters/1")},
        ]
    },
    "analytics": {
        "gameKey": "",
        "secretKey": "",
    },
    "audio": {
        // ...
    },
    "images": {
        "images": {
            "prince": require("@fae/source/assets/images/teach-tactics/mapsprite-PRINCE.png"),
            "jockred": require("@fae/source/assets/images/teach-tactics/mapsprite-JOCKRED.png"),
            "jockgreen": require("@fae/source/assets/images/teach-tactics/mapsprite-JOCKGREEN.png"),
            "prepred": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPRED.png"),
            "prepgreen": require("@fae/source/assets/images/teach-tactics/mapsprite-PREPGREEN.png"),
        },
        "weapons": {
            "sword": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.sword.png"),
            "daggers": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.daggers.png"),
            "spear": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.spear-teach.png"),
            "bow": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.bow-teach.png"),
            "axe": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.hammer.png"),
            "gun": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.gun.png"),
            "staff": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.staff.blue-teach.png"),
            "red-staff": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.staff.red.png"),
            "blue-staff": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.staff.blue-teach.png"),
            "green-staff": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.staff.green.png"),
            "yellow-staff": require("@fae/source/assets/images/frog-tactics/stage/units/parts/weapon.staff.yellow.png"),
            "red-shield": require("@fae/source/assets/images/frog-tactics/stage/units/parts/decal.shield.red.png"),
        },
    }
}
